import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Eyebrow, Reveal } from "./Motion";

const TEXT =
  "We share the goals and aspirations of both our brands and our retailers — sourcing innovative, credible fashion through a European and international network, and placing the right product with the right retailers for long-term success.";

const Word = ({ children, progress, range }) => {
  const opacity = useTransform(progress, range, [0.22, 1]);
  return <motion.span style={{ opacity }} className="mr-[0.25em] inline-block">{children}</motion.span>;
};

const STATS = [
  { n: "45", l: "Years in Irish fashion" },
  { n: "09", l: "International brands" },
  { n: "32", l: "Counties served" },
  { n: "2005", l: "HQ & showrooms opened" },
];

export const Manifesto = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 0.85", "end 0.45"] });
  const words = TEXT.split(" ");
  return (
    <section ref={ref} data-testid="manifesto-section" className="mx-auto max-w-[1600px] px-6 py-28 sm:px-10 sm:py-40 lg:px-14">
      <Eyebrow index="01">The House</Eyebrow>
      <p className="mt-12 max-w-6xl font-display text-[2.1rem] leading-[1.12] sm:text-5xl lg:text-[4.2rem]">
        {words.map((w, i) => (
          <Word key={i} progress={scrollYProgress} range={[i / words.length, (i + 1) / words.length]}>{w}</Word>
        ))}
      </p>
      <div className="mt-24 grid grid-cols-2 border-t border-white/10 lg:grid-cols-4">
        {STATS.map((s, i) => (
          <Reveal key={s.l} delay={i * 0.08} className="border-b border-white/10 py-8 pr-6 lg:border-b-0 lg:border-r lg:last:border-r-0 lg:pl-6 lg:first:pl-0">
            <div data-testid={`stat-${i}`} className="font-display text-6xl text-[#f5f3ef] sm:text-7xl">{s.n}</div>
            <div className="mt-3 font-mono text-xs uppercase tracking-[0.2em] text-[#b4b2ad]">{s.l}</div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
